import { memo, forwardRef } from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { useFloating } from '@/hooks/useParallax';

interface AnimatedCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  floating?: boolean;
  floatingDuration?: number;
  hoverScale?: boolean;
  glowEffect?: boolean;
}

const AnimatedCard = memo(forwardRef<HTMLDivElement, AnimatedCardProps>(
  ({ 
    children, 
    className, 
    floating = false, 
    floatingDuration = 3000,
    hoverScale = true,
    glowEffect = false,
    ...props 
  }, ref) => {
    const floatingStyle = useFloating(floatingDuration);

    return (
      <Card
        ref={ref}
        className={cn(
          'transition-all duration-300 ease-out',
          hoverScale && 'hover:scale-[1.02] hover:-translate-y-1',
          glowEffect && 'hover:shadow-lg hover:shadow-cyan-400/10',
          className
        )}
        style={floating ? floatingStyle.style : undefined}
        {...props}
      >
        {children}
      </Card>
    );
  }
));

AnimatedCard.displayName = 'AnimatedCard';

export { AnimatedCard };